import React, { useState, useEffect, useCallback } from 'react';
import './LiveNumber.css';

/**
 * 数字波动动画：让 TVL/APY/进度等静态数字产生真实感波动。
 * 用法：<LiveNumber base={86.5} decimals={1} suffix="%" drift={0.3} />
 * 每 3-8 秒在 ±drift 范围内微调。
 */
const LiveNumber = ({ base, decimals = 1, prefix = '', suffix = '', drift = 0.5 }) => {
  const [value, setValue] = useState(base);

  useEffect(() => {
    let alive = true;
    let timer;
    const tick = () => {
      const next = base + (Math.random() * 2 - 1) * drift;
      setValue(next);
      timer = setTimeout(tick, 3000 + Math.random() * 5000);
    };
    timer = setTimeout(tick, 2000 + Math.random() * 3000);
    return () => { alive = false; clearTimeout(timer); };
  }, [base, drift]);

  return (
    <span className="live-num">
      {prefix}{Number(value).toFixed(decimals)}{suffix}
    </span>
  );
};

export default LiveNumber;
